import { useMemo } from 'react';
import { useSession } from 'next-auth/react';

const DEFAULT_AVATAR = '/assets/images/users/avatar-1.png';
const DEFAULT_THUMB = '/assets/images/users/avatar-thumb-1.png';

export interface UserProps {
  id: string;
  name: string;
  email: string;
  avatar: string;
  thumb: string;
  user: unknown;
}

const useUser = (): UserProps | null => {
  const { data: session } = useSession();

  return useMemo(() => {
    if (!session) return null;

    const user = session.user;
    const provider = session.provider;

    let name = user?.name ?? 'Unknown';
    if (provider === 'cognito' && user?.email) {
      name = user.email.split('@')[0] ?? 'Unknown';
    }

    const avatar = user?.image ?? DEFAULT_AVATAR;
    const thumb = user?.image ? user.image : DEFAULT_THUMB;

    return {
      id: session.id,
      name,
      email: user?.email ?? '',
      avatar,
      thumb,
      user: session.token
    };
  }, [session]);
};

export default useUser;
